import { create } from "zustand";

interface TerritoriesState {
	importModalOpen: boolean;
	organizationId: string | null;
}

interface TerritoriesActions {
	openImportModal: (organizationId: string) => void;
	closeImportModal: () => void;
}

type TerritoriesStore = TerritoriesState & TerritoriesActions;

export const useTerritoriesStore = create<TerritoriesStore>((set) => ({
	importModalOpen: false,
	organizationId: null,

	openImportModal: (organizationId) => {
		set({ importModalOpen: true, organizationId });
	},

	closeImportModal: () => {
		set({ importModalOpen: false, organizationId: null });
	},
}));
